var PlayerModes;
(function (PlayerModes) {
    PlayerModes[PlayerModes["INTERACTIVE"] = 0] = "INTERACTIVE";
    PlayerModes[PlayerModes["VIRTUAL_PRESENTER"] = 1] = "VIRTUAL_PRESENTER";
    PlayerModes[PlayerModes["VIRTUAL_ATTENDEE"] = 2] = "VIRTUAL_ATTENDEE";
    PlayerModes[PlayerModes["NON_INTERACTIVE"] = 3] = "NON_INTERACTIVE";
})(PlayerModes || (PlayerModes = {}));
export var PDFMessageTypes;
(function (PDFMessageTypes) {
    PDFMessageTypes["LOAD_FILE"] = "LOAD_FILE";
    PDFMessageTypes["IFRAME_LOADED"] = "IFRAME_LOADED";
    PDFMessageTypes["PDF_PAGE_LOADED"] = "PDF_PAGE_LOADED";
    PDFMessageTypes["PLAYER_MODE"] = "PLAYER_MODE";
    PDFMessageTypes["PLAYER_CONTROL"] = "PLAYER_CONTROL";
    PDFMessageTypes["PPZ_TRANSFORM"] = "PPZ_TRANSFORM";
    PDFMessageTypes["SET_PRESENTATION_STATE"] = "SET_PRESENTATION_STATE";
    PDFMessageTypes["SET_VISIBLE_PAGES"] = "SET_VISIBLE_PAGES";
    PDFMessageTypes["SET_PRESENTATION_META"] = "SET_PRESENTATION_META";
    PDFMessageTypes["PAGE_CHANGE"] = "PAGE_CHANGE";
    PDFMessageTypes["DOCUMENT_LOADED"] = "DOCUMENT_LOADED";
    PDFMessageTypes["NAVIGATE_PAST_FIRST"] = "NAVIGATE_PAST_FIRST";
    PDFMessageTypes["NAVIGATE_PAST_LAST"] = "NAVIGATE_PAST_LAST";
    PDFMessageTypes["SWIPE_VERTICAL"] = "SWIPE_VERTICAL";
    PDFMessageTypes["SHOW_SEARCH"] = "SHOW_SEARCH";
    PDFMessageTypes["SHOW_MY_CONTENT"] = "SHOW_MY_CONTENT";
    PDFMessageTypes["CURRENT_CONTENT_INFO"] = "CURRENT_CONTENT_INFO";
})(PDFMessageTypes || (PDFMessageTypes = {}));
// hooks
export { default as useOnlineStatus } from './hooks/useOnlineStatus/useOnlineStatus';
export { default as useInterval } from './hooks/useInterval/useInterval';
export * from './types/cacheDB';
export * from './types/workerChannel';
export * from './types/auth';
export { PresentationContext, VirtualPresentationContext, usePresentationContext, } from './state/context/PresentationPlayer/PresentationContext';
export { PRESENTATION_MODE, PRESENTATION_CONTEXT, } from './state/context/PresentationPlayer/types';
// util
export { reachabilityMonitor } from './hooks/useOnlineStatus/useOnlineStatus';
export { default as WebLinking } from './util/WebLinking';
//# sourceMappingURL=index.js.map